<template>
  <div>
    <div class="list-page-header">
      <h3 class="title font-medium text-2xl">
        {{ $t("common.my_profile") }}
      </h3>
    </div>
    <div class="fixed-plugin change-pwd">
      <button-change-password
        @showChangePasswordModal="showChangePasswordModal()"
      >
      </button-change-password>
    </div>
    <change-password
      :name="changePasswordModal.name"
      :title="changePasswordModal.title"
      :uuid="uuid"
    ></change-password>

    <validation-form @on-submit="updateProfileFamily">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card class="card-content">
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title text-lg">
                  {{ $t("student.main_information") }}
                </h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout mt-15">
                <!-- USERNAME -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("common.username") }}</label>
                    <md-input
                      required
                      v-model.trim="form.username"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <!-- USERNAME -->

                <!-- Sex -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("common.sex") }}</label>
                    <md-select
                      name="sex"
                      id="personal-gender"
                      v-model="form.sex"
                    >
                      <md-option value="Male">{{ $t("staff.male") }}</md-option>
                      <md-option value="Female">{{
                        $t("staff.female")
                      }}</md-option>
                      <md-option value="Other">{{
                        $t("common.other")
                      }}</md-option>
                    </md-select>
                  </md-field>
                </div>
                <!-- Sex -->

                <!-- STATUS -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("common.status") }}</label>
                    <md-select
                      name="status"
                      id="personal-status"
                      v-model="form.status"
                      disabled
                    >
                      <md-option value="Active">{{
                        $t("common.active")
                      }}</md-option>
                      <md-option value="Inactive">{{
                        $t("common.inactive")
                      }}</md-option>
                    </md-select>
                  </md-field>
                </div>
                <!-- STATUS -->

                <!-- FIRSTNAME -->
                <div
                  class="md-layout-item md-size-33 md-small-size-100"
                  :class="styleErrorServer('first_name')"
                >
                  <validation-field
                    :validations="validationsStudent.first_name"
                    :field-class="getValidationClass('first_name')"
                    name="first name"
                  >
                    <label>{{ $t("common.first_name") }}</label>
                    <md-input
                      required
                      v-model.trim="form.first_name"
                    ></md-input>
                    <span
                      class="md-error"
                      v-if="serverValidations.first_name"
                      >{{ serverValidations.first_name }}</span
                    >
                  </validation-field>
                </div>
                <!-- FIRSTNAME -->

                <!-- MIDDLE_NAME -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("common.middle_name") }}</label>
                    <md-input v-model.trim="form.middle_name"></md-input>
                  </md-field>
                </div>
                <!-- MIDDLE_NAME -->

                <!-- LASTNAME -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="validationsStudent.last_name"
                    :field-class="getValidationClass('last_name')"
                    name="last name"
                  >
                    <label>{{ $t("common.last_name") }}</label>
                    <md-input required v-model.trim="form.last_name"></md-input>
                  </validation-field>
                </div>
                <!-- LASTNAME -->

                <!-- EMAIL -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("common.email") }}</label>
                    <md-input
                      required
                      v-model.trim="form.email"
                      disabled
                    ></md-input>
                  </md-field>
                </div>
                <!-- EMAIL -->

                <!-- PHONE_NUMBER -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("common.phone_number") }}</label>
                    <md-input v-model.trim="form.phone_number"></md-input>
                  </md-field>
                </div>
                <!-- PHONE_NUMBER -->

                <!-- RELATIONSHIP -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("student.relationship") }}</label>
                    <md-input v-model.trim="form.relationship"></md-input>
                  </md-field>
                </div>
                <!-- RELATIONSHIP -->
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <footer class="flex justify-center">
        <md-button @click="goToPreviousPage">{{
          $t("common.cancel")
        }}</md-button>
        <md-button class="md-success ml-4" type="submit">{{
          $t("common.update")
        }}</md-button>
      </footer>
    </validation-form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import pick from "lodash/pick";
import { validations } from "@/validations/students";
import { Message, getId, genErrMsgOj } from "@/helpers/utils";
import { service_names } from "@/constants/Services";
import ChangePassword from "../ChangePassword";
import ButtonChangePassword from "@/components/Base/ButtonChangePassword.vue";

export default {
  components: { ChangePassword, ButtonChangePassword },
  data() {
    return {
      form: {
        username: null,
        sex: null,
        first_name: null,
        middle_name: null,
        last_name: null,
        status: null,
        email: null,
        phone_number: null,
        relationship: null
      },
      validationsStudent: validations,
      serverValidations: {},
      changePasswordModal: {
        name: "change-password",
        title: "student.change_password"
      }
    };
  },
  watch: {
    "form.first_name": function() {
      this.serverValidations.first_name &&
        delete this.serverValidations.first_name;
    },

    "form.last_name": function() {
      this.serverValidations.last_name &&
        delete this.serverValidations.last_name;
    }
  },
  computed: {
    ...mapState("user", ["info"]),
    ...mapState("switchAccountChild", ["currentChild", "accChildren"])
  },
  created() {
    this.form = pick(this.info, Object.keys(this.form));
  },
  methods: {
    goToPreviousPage() {
      this.$router.push("/");
    },

    showChangePasswordModal() {
      this.$modal.show(this.changePasswordModal.name);
    },

    updateProfileFamily() {
      this.$axios
        .put(`${service_names.user}/families/${getId(this.info)}`, this.form)
        .then(() => {
          Message.success(this.$t("common.update_success"));
        })
        .catch(error => {
          const errData = error.response?.data;
          if (errData) {
            this.serverValidations = genErrMsgOj(errData.messages);
          }
        });
    },

    styleErrorServer(fieldName) {
      return {
        "mb-20": !!this.serverValidations[fieldName]
      };
    },

    getValidationClass(fieldName) {
      return {
        "md-invalid": !!this.serverValidations[fieldName]
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.list-page-header {
  padding-left: 15px;
  margin: 40px 0;
}
input:disabled,
.md-select.md-disabled {
  background: rgba(196, 196, 196, 0.3);
}
</style>
